import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  TabbedShowLayout,
  useTranslate,
  DateField,
} from "react-admin";
import Box from "@mui/material/Box";

const AccountReceivablePcmCardExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();
  return (
    <Box
      sx={{
        m: 5,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper", // "#fff",
      }}
    >
      {record.checks ? (
        <Box
          component="table"
          sx={{
            width: "100%",
            // bgcolor: "rgba(0,0,0,.04)",
            // fontSize: "smaller",
            borderCollapse: "collapse",
            "& th, td": {
              padding: "6px 8px",
              border: "1px solid #dddddd",
            },
          }}
        >
          <thead>
            <tr>
              <th>{t("mine.label.check_number")}</th>
              <th>{t("mine.label.bank_name")}</th>
              <th>{t("mine.label.received_date")}</th>
              <th>{t("mine.label.effective_date")}</th>
              <th>{t("mine.label.payment_code")}</th>
              <th style={{ textAlign: "right" }}>{t("mine.label.balance")}</th>
            </tr>
          </thead>
          <tbody>
            {record.checks.map((item, idx) => {
              return (
                <tr key={item.check_number + idx}>
                  <td>{item.check_number}</td>
                  <td>{item.bank_name}</td>
                  <td>
                    <RecordContextProvider value={item}>
                      <DateField
                        source="received_date"
                        sx={{
                          fontSize: "inherit",
                        }}
                      />
                    </RecordContextProvider>
                  </td>
                  <td>
                    <RecordContextProvider value={item}>
                      <DateField
                        source="effective_date"
                        sx={{
                          fontSize: "inherit",
                        }}
                      />
                    </RecordContextProvider>
                  </td>
                  <td>{item.payment_code}</td>
                  <td style={{ textAlign: "right" }}>
                    <RecordContextProvider value={item}>
                      <NumberField
                        source="balance"
                        sx={{
                          fontSize: "inherit",
                        }}
                      />
                    </RecordContextProvider>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Box>
      ) : null}
    </Box>
  );
};

export default AccountReceivablePcmCardExpandList;
